<template>
  <el-container>
    <el-row class="work-bfb">
      <el-button type="primary" class="tool-button-sub" @click="confirmLink" v-show="isLinkingCustomer">确认关联</el-button>
        <el-table ref="table" :data="customerList" class="log-table table-main"  @select="select" @select-all="select" :header-cell-style="{background:'#f5f5f5',height:'',borderRight: '1px solid #fff',textAlign:'center'}">
         <el-table-column
            type="selection"
            align="center" disabled='true'
            label="选择" v-if="isLinkingCustomer">
          </el-table-column>
          <el-table-column align="center" prop="nameCn" label="名称"></el-table-column>
          <el-table-column align="center" prop="property" label="属性"></el-table-column>
          <el-table-column align="center" prop="source" label="来源"></el-table-column>
          <el-table-column align="center" prop="phone" label="电话"></el-table-column>
          <el-table-column align="center" prop="level" label="等级"></el-table-column>
          <el-table-column align="center" prop="addr" label="地址"></el-table-column>
          <el-table-column align="center" prop="email" label="邮箱"></el-table-column>
        </el-table>
        <el-pagination class="work-mt30"
        @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
    </el-row>
  </el-container>
</template>

<script>
export default {
  name: 'Contant',
  data() {
    return {
      form: {
        page: 1,
        limit: 10
      },
      total: 0,
      isLinkingCustomer: true,
      customerList: []
    }
  },
  props: [],
  components: {},
  mounted() {
    this.getCustomerList()
    if (this.$route.params.isFromCreateOrder) {
      this.isLinkingCustomer = true
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.form.page = page
      this.getCustomerList()
    },
    getCustomerList() {
      const that = this
      const params = {
        current: this.form.page,
        size: this.form.limit,
        orders: null,
        search: {
          source: 'AICC_CRM'
        }
      }

      this.$http.post(window.$envUtils('VUE_APP_CRM_SERVICE') + '/customer/findByPage', {
        data: params
      }).then(function(res) {
        if (res.data.code === '2000') {
          that.customerList = res.data.data.records
          that.total = res.data.data.total
        }
      }).catch(function(error) {
        console.log(error)
      })
    },
    select(selection, row) {
      this.$refs.table.clearSelection()
      this.$refs.table.toggleRowSelection(row)
      const order = this.$store.state.order.order
      this.$set(order, 'customer', row)
      this.$set(order, 'customerId', row.id)
      this.$store.commit('order/saveOrder', order)
    },
    confirmLink() {
      this.$emit('confirmLink', false)
    }
  }
}
</script>
<style scoped>
.el-pagination {
  text-align: right;
  margin-top:10px
}

.el-checkbox:last-of-type {
    display: none;
}
</style>
